import { render, staticRenderFns } from "./BookingTable.vue?vue&type=template&id=9b974f62"
import script from "./BookingTable.vue?vue&type=script&lang=js"
export * from "./BookingTable.vue?vue&type=script&lang=js"
import style0 from "./BookingTable.vue?vue&type=style&index=0&id=9b974f62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports